import React from 'react';
import { Box, Card, CardContent, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import SignalWifi4BarIcon from '@mui/icons-material/SignalWifi4Bar';
import BarChartIcon from '@mui/icons-material/BarChart';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsIcon from '@mui/icons-material/Settings';

const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 400, // Increased width
  height: 320,  // Increased height
  margin: '0 auto',
  borderRadius: 16,
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#fff',
  '&:hover': {
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)',
  },
  textAlign: 'center',
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  fontFamily: 'Poppins, sans-serif', // Set Poppins font family for the card
}));

const Services = () => {
  return (
    <Box
      sx={{
        color: '#fff',
        py: 6,
        textAlign: 'center',
        position: 'relative',
        fontFamily: 'Poppins, sans-serif', // Set Poppins for the outer Box
      }}
    >
      <Typography variant="h4" component="h2" gutterBottom sx={{ color: '#000080', fontWeight: 'bold', fontFamily: 'Poppins, sans-serif' }}>
        Services We Offer
      </Typography>
      <Typography variant="body1" component="p" sx={{ color: '#000', mb: 4, fontFamily: 'Poppins, sans-serif' }}>
        We offer the best services around - from installations to repairs, maintenance, and more!
      </Typography>
      <Grid
        container
        spacing={4} // Consistent spacing between all cards
        justifyContent="center"
        sx={{ maxWidth: '1400px', margin: '0 auto' }} // Adjusted maxWidth to accommodate larger cards
      >
        <Grid item xs={12} md={4}>
          <StyledCard>
            <CardContent>
              <SignalWifi4BarIcon sx={{ fontSize: 80, color: '#000080', mb: 2 }} />
              <Typography variant="h6" component="div" sx={{ color: '#000080', mb: 1, fontFamily: 'Poppins, sans-serif' }}>
                VIP Forex Signals ...
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                We provide premium real-time trading signals to help you make informed decisions in the forex market, with entry and exit points.
              </Typography>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <StyledCard>
            <CardContent>
              <BarChartIcon sx={{ fontSize: 80, color: '#000080', mb: 2 }} />
              <Typography variant="h6" component="div" sx={{ color: '#000080', mb: 1, fontFamily: 'Poppins, sans-serif' }}>
                Financial Advisory
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                A comprehensive tutoring program where you can learn forex trading strategies, technical analysis, and risk management from beginner ...
              </Typography>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <StyledCard>
            <CardContent>
              <ManageAccountsIcon sx={{ fontSize: 80, color: '#000080', mb: 2 }} />
              <Typography variant="h6" component="div" sx={{ color: '#000080', mb: 1, fontFamily: 'Poppins, sans-serif' }}>
                Management
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                There’s me, your friendly neighborhood reporter’s news analyst processes and improving
              </Typography>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <StyledCard>
            <CardContent>
              <AssessmentIcon sx={{ fontSize: 80, color: '#000080', mb: 2 }} />
              <Typography variant="h6" component="div" sx={{ color: '#000080', mb: 1, fontFamily: 'Poppins, sans-serif' }}>
                Performance Analysis
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                Detailed analysis of your trading performance to optimize your strategies and outcomes.
              </Typography>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} md={4}>
          <StyledCard>
            <CardContent>
              <SettingsIcon sx={{ fontSize: 80, color: '#000080', mb: 2 }} />
              <Typography variant="h6" component="div" sx={{ color: '#000080', mb: 1, fontFamily: 'Poppins, sans-serif' }}>
                System Configuration
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
                Custom setup and configuration of trading systems to suit your specific needs.
              </Typography>
            </CardContent>
          </StyledCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Services;